import { HelpCircle } from "lucide-react";

export default function Hero({
  onOpenHelp,
  onOpenInverse,
  onOpenPremium,
  onStart,
  isPremium = false,
}: {
  onOpenHelp?: () => void;
  onOpenInverse?: () => void;
  onOpenPremium?: () => void;
  onStart?: () => void;
  isPremium?: boolean;
}) {
  return (
    <section className="hero-shell">
      <div className="hero-card">
        <div className="hero-badge">Simulador 100% actualizado · Normativa 2025/2026</div>

        {isPremium && (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "4px 10px",
              borderRadius: 5,
              marginBottom: 14,
              background: "var(--accent-soft)",
              border: "1px solid rgba(24,82,214,.15)",
              fontSize: 11,
              fontWeight: 700,
              color: "var(--accent-text)",
              letterSpacing: ".06em",
              textTransform: "uppercase",
            }}
          >
            ✦ Premium activo
          </div>
        )}

        <h1 className="h1" style={{ marginBottom: 16 }}>
          Calcula cuánto te queda como autónomo,
          <br />
          <em style={{ color: "var(--accent)", fontStyle: "normal" }}>sin sorpresas</em>
        </h1>

        <p
          className="sub"
          style={{
            maxWidth: 720,
            margin: "0 auto",
            fontSize: "clamp(15px, 2vw, 18px)",
          }}
        >
          IRPF, cuota de autónomos e IVA calculados con precisión según tu comunidad
          autónoma. Sin sorpresas.
        </p>

        <div className="hero-actions">
          <button type="button" className="hero-cta primary" onClick={onStart}>
            Empezar cálculo
          </button>
          <button type="button" className="hero-cta secondary" onClick={onOpenInverse}>
            Quiero cobrar X neto →
          </button>
          {!isPremium && (
            <button
              type="button"
              className="hero-cta secondary"
              onClick={onOpenPremium}
            >
              Alta Premium <span style={{ color: "var(--success)" }}>— gratis</span>
            </button>
          )}
        </div>

        {onOpenHelp && (
          <div className="hero-subactions">
            <button type="button" className="hero-link-btn" onClick={onOpenHelp}>
              <HelpCircle size={16} />
              Guía rápida y glosario
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
